import { canonicalize } from '@meteor/canonicalize';
import { createLoader } from '@meteor/data-hooks';
import { useRef, useState } from 'react';
import { withAuth } from '../../user';
import { consumerClient } from '../client';

export let clientUsersLoader = createLoader({
  name: 'clientUsers',
  hash: i => canonicalize(i),
  fetch: (i: {
    instanceId: string;
    organizationId?: string;
    cursor?: string;
    withDeleted?: boolean;
  }) => withAuth(() => consumerClient.user.list(i)),
  mutators: {
    create: (i: {
      instanceId: string;
      name: string;
      email?: string;
      metadata?: Record<string, any>;
    }) => withAuth(() => consumerClient.user.create(i))
  }
});

export let useClientUsers = (instanceId: string | null, organizationId?: string | null) => {
  let [cursor, setCursor] = useState<string>();
  let users = clientUsersLoader.use(
    instanceId ? { cursor, instanceId, organizationId: organizationId || undefined } : null
  );

  let dataRef = useRef(users.data);
  dataRef.current = users.data;

  return {
    ...users,
    createMutator: users.useMutator('create'),
    next: () => {
      let c = dataRef.current?.pagination.afterCursor;
      if (c) setCursor(c);
    },
    previous: () => {
      let c = dataRef.current?.pagination.beforeCursor;
      if (c) setCursor(c);
    }
  };
};

export let clientUserLoader = createLoader({
  name: 'clientUser',
  fetch: (i: { userId: string; instanceId: string }) =>
    withAuth(() => consumerClient.user.get(i)),
  mutators: {
    update: (i: {
      userId: string;
      instanceId: string;
      name?: string;
      email?: string;
      metadata?: Record<string, any>;
    }) => withAuth(() => consumerClient.user.update(i))
  }
});

export let useClientUser = (userId: string | null, instanceId: string | null) => {
  let user = clientUserLoader.use(userId && instanceId ? { userId, instanceId } : null);

  return {
    ...user,
    updateMutator: user.useMutator('update')
  };
};
